/**
 * ZYPHERON AI Logo Assets
 * Centralized logo path exports for React components
 */

import logoUserSelected from './branding/logo-user-selected.png'

// Public logo paths (served by Vite dev server)
export const ZYPHERON_LOGOS = {
  // Main detailed logo with "ZYPHERON AI" text
  main: logoUserSelected,

  // Small geometric icon for headers/navigation
  icon: logoUserSelected,

  // Additional variants
  variant1: logoUserSelected,
  variant2: logoUserSelected,
  variant3: logoUserSelected,

  // Alternative paths for assets directory (if needed for imports)
  mainAsset: logoUserSelected,
  iconAsset: logoUserSelected
}

// Logo specifications
export const LOGO_SPECS = {
  colors: {
    primary: '#ef4444',      // Main cobra red
    dark: '#1a1a1a',         // Dark accents
    secondary: '#dc2626'     // Secondary red
  },

  sizes: {
    main: { width: 800, height: 800 },
    icon: { width: 200, height: 200 }
  },

  usage: {
    main: ['welcome screens', 'hero sections', 'main branding'],
    icon: ['headers', 'navigation', 'favicon', 'small spaces']
  }
}

// Component usage examples
export const USAGE_EXAMPLES = {
  mainLogo: `<img src="/zypheron-logo.svg" alt="ZYPHERON AI" className="w-48 h-48" />`,
  iconLogo: `<img src="/zypheron-icon.svg" alt="ZYPHERON AI Logo" className="w-8 h-8" />`,
  reactImport: `import { ZYPHERON_LOGOS } from '@/assets/logos'`
}

// Default exports for convenience
export default ZYPHERON_LOGOS 